import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
const faqs = [{
  question: '¿En cuánto tiempo veo resultados?',
  answer: 'La mayoría de nuestras clientas notan diferencia en las primeras 72 horas gracias al efecto drenante. El cambio real en la silueta se consolida al completar el protocolo de 21 días.'
}, {
  question: '¿La faja se enrolla como las comunes?',
  answer: 'No. Nuestro material reforzado de alta densidad está diseñado con una estructura semirrígida que se mantiene en su lugar, evitando el molesto enrollamiento al sentarte o moverte.'
}, {
  question: '¿Hacen envíos a todo el país?',
  answer: 'Sí, enviamos a toda Argentina con seguimiento. Trabajamos con correo privado para asegurar que tu kit llegue rápido y seguro a tu domicilio o sucursal más cercana.'
}, {
  question: '¿Qué incluye el Ebook Método 21D?',
  answer: 'Incluye el protocolo completo de 21 días con guía de uso progresivo de la faja, técnicas de automasaje linfático y tips de nutrición anti-inflamatoria. Es un archivo digital que recibís al instante.'
}, {
  question: '¿Puedo usarla post-parto?',
  answer: 'Sí, es ideal para recuperación post-parto ya que ayuda a contener la zona abdominal y favorece el retorno de los tejidos. Siempre recomendamos consultar con tu médico el momento ideal para comenzar.'
}];
export function FAQSection() {
  const [activeIndex, setActiveIndex] = useState<number | null>(null);
  return <section className="py-20 px-4 md:px-8 bg-white" data-id="element-31">
      <div className="max-w-3xl mx-auto" data-id="element-32">
        <div className="text-center mb-12" data-id="element-33">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-brown-deep" data-id="element-34">
            Preguntas Frecuentes
          </h2>
        </div>

        <div className="space-y-4" data-id="element-35">
          {faqs.map((faq, index) => <div key={index} className="border border-gray-200 rounded-xl overflow-hidden" data-id="element-36">
              <button onClick={() => setActiveIndex(activeIndex === index ? null : index)} className="w-full flex items-center justify-between p-6 bg-white hover:bg-gray-50 transition-colors text-left" data-id="element-37">
                <span className="font-bold text-brown-deep text-lg" data-id="element-38">
                  {faq.question}
                </span>
                <ChevronDown className={`w-5 h-5 text-brown-medium transition-transform duration-300 ${activeIndex === index ? 'rotate-180' : ''}`} data-id="element-39" />
              </button>
              <AnimatePresence data-id="element-40">
                {activeIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-41">
                    <div className="p-6 pt-0 text-brown-medium leading-relaxed border-t border-gray-100" data-id="element-42">
                      {faq.answer}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </section>;
}